import { useCallback } from "react";

export const useCleanupPaymentScript = (iframeUrl?: string) => {
  return useCallback(() => {
    document.querySelector(".PensioEmbeddedPaymentWindow")?.remove();
    document.querySelector(".PensioEmbeddedPaymentWindowBackground")?.remove();
  }, [iframeUrl]);
};
